export enum AccionBoton {
    Cerrar = 1,
    RetornarAgaval = 2,
    CancelarSolicitud = 3,
    RetornarPreguntas = 4,
    ReintentoSolicitudVinculacion = 5,
    CancelarSolicitudVoluntaria = 6,
    IniciarSolicitudVinculacion = 7,
    IniciarReintentoSolicitudVinculacion = 8,
    ReintentoFalloOTP = 9,
    IniciarReintentoFalloOTP = 10,
    RedireccionarACompras = 11,
    Redireccionar = 12
}
